/**
 * MonitoringDot - Pulsing teal indicator for active monitoring
 *
 * Renders a small pulsing circle when a collection is actively monitoring.
 * Not rendered when paused (no DOM element, not just hidden).
 *
 * Atomic level: Atom
 */

import React from 'react';
import type { MonitoringStatus } from '../../../../services/types/collection';

interface MonitoringDotProps {
  status: MonitoringStatus;
  className?: string;
}

const MonitoringDot: React.FC<MonitoringDotProps> = ({ status, className = '' }) => {
  if (status !== 'active') return null;

  return (
    <span
      className={`inline-block w-1.5 h-1.5 rounded-full bg-[#07A0C3] animate-monitoring-pulse ${className}`}
      title="Monitoring — connected and running"
    />
  );
};

export { MonitoringDot };
export type { MonitoringDotProps };
